import { BusinessController } from '../../controllers';
import { BusinessInfo } from '../../pages/Settings';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { string, object } from 'yup';

const BusinessInfoContainer = ({ closeModal }) => {
	let {
		appStore: { loading },
		businessStore,
	} = useStores();
	const [editState, setEditState] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: 'image/*' });
	};

	const goBack = () => {
		if (editState) {
			setEditState(false);
		} else {
			closeModal();
		}
	};

	const goToEditState = () => {
		setEditState(!editState);
	};

	const validationSchema = () =>
		object({
			address: string().optional(),
			webAddress: string().optional(),
			instagram: string().optional(),
			twitter: string().optional(),
		});

	const onSubmit = async values => {
		const formData = new FormData();
		appStore.setLoading(true);
		const payload = {};
		let fileToSend;

		if (file) {
			if (typeof file.source === 'string') {
				fileToSend = await fetch(file.source)
					.then(response => response.blob())
					.then(
						blob =>
							new File([blob], 'name', {
								type: blob.type,
								lastModified: new Date(),
							})
					);
				formData.append('logo', fileToSend);
			}
		}

		if (values.instagram) payload.instagramHandle = values.instagram;
		if (values.twitter) payload.twitterHandle = values.twitter;
		if (values.webAddress) payload.website = values.webAddress;
		if (values.address) payload.businessAddress = values.address;
		values.bvn = businessStore.business.bvn;
		for (const [key, value] of Object.entries(payload)) {
			formData.append(key, value);
		}
		const { status, errorMessage } = await BusinessController.update(formData);
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return setEditState(false);
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<BusinessInfo
			loading={loading}
			selectClick={selectClick}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			business={businessStore.business}
			closeModal={closeModal}
			file={file}
			editState={editState}
			goToEditState={goToEditState}
			goBack={goBack}
		/>
	);
};

export default observer(BusinessInfoContainer);
